import { GenericMachine } from '_core/domain/Utils/Generic/Machines/GenericMachine';
import { IDocs } from '_core/types';
import { ErrorsFlowTypes } from '_core/types/Responses';
import { Bundle } from '_core/util';
import { memberApi as API } from '../Apis';

export const CreateMemberDocs: IDocs = {
  title: 'CreateMember',
  description: '',
  version: '0.0.1',
  apis: [
    {
      name: API.definitions.API_DOMAIN,
      path: API.definitions.ENDPOINT_API_PATH,
      linkPostman: API.definitions.URL_POSTMAN,
      order: 1,
    },
  ],
  codeToExecute: 'Services.AccountServices.createMember',
};

const prepareCall = (stateRequestParameters: any) => {
  const config = Bundle.getValue('config');
  return API.call.post({
    name: stateRequestParameters.name,
    password: stateRequestParameters.password,
    passwordConfirmation: stateRequestParameters.password,
    allowMail: true,
    allowSMS: stateRequestParameters.allowSMS,
    allowPromoEmail: stateRequestParameters.allowPromoEmail,
    birthDate: stateRequestParameters.birthDate,
    phoneList: [
      {
        type: 'CELLULAR',
        internationalCode: stateRequestParameters?.cellPhone?.DDI,
        areaCode: stateRequestParameters?.cellPhone?.DDD,
        number: stateRequestParameters?.cellPhone?.number,
      },
    ],
    documentList: [
      {
        preferential: true,
        type: stateRequestParameters?.document.type,
        number: stateRequestParameters?.document.value,
      },
    ],
    addressList: [
      {
        preferential: true,
        type: 'HOME',
        streetName: stateRequestParameters?.address?.streetName,
        streetNumber: stateRequestParameters?.address?.streetNumber,
        complement: stateRequestParameters?.address?.complement,
        zipCode: stateRequestParameters?.address?.zipCode,
        city: stateRequestParameters?.address?.city,
        state: stateRequestParameters?.address?.state,
        country: stateRequestParameters?.address?.country,
      },
    ],
    electronicAddressList: [
      {
        preferential: true,
        type: 'PERSONAL',
        address: stateRequestParameters.email,
      },
    ],
    acceptTerms: stateRequestParameters.acceptTerms,
    deviceFingerprint: stateRequestParameters.deviceFingerprint,
    minorLegalGuardian: stateRequestParameters?.minorLegalGuardian,
    recaptcha:
      config.service.environment === 'MOCK'
        ? undefined
        : { responseToken: stateRequestParameters?.tokenRecaptcha },
  });
};

const handleSucessFinalResponseFunction = (data: any) => {
  Bundle.clearValue('smilesToken');
  return data;
};

const handleErrorFlowFinalResponseFunction = (infos: ErrorsFlowTypes) => {
  const smilesCheckAccount = !infos?.errorService;
  const smilesErrorService = infos?.errorService || !smilesCheckAccount;

  return { smilesCheckAccount, smilesErrorService };
};

export const CreateMemberMachine = GenericMachine(
  prepareCall,
  {
    docs: CreateMemberDocs,
    definitions: API.definitions,
  },
  {
    handleSucessFinalResponseFunction,
    handleErrorFlowFinalResponseFunction,
  },
);
